import {Injectable, inject, signal} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class FilesMappingService {
  private translate = inject(TranslateService);

  filterAndMapFiles(source: any, externalSelectedFiles?: File[], id?: number): { files: any, error: string | null } {
    let errorMsg: string | null = null;
    const pattern = source?.pattern;
    const files = externalSelectedFiles?.filter((file: File) => {
      const regex = new RegExp(pattern, 'i');
      if (id) {
        const sourceFormat = source?.sourceFormat?.toLowerCase();
        const extension = file?.name?.split('.')?.pop()?.toLowerCase();
        if (sourceFormat && sourceFormat !== extension && pattern && this.validatePattern(pattern) && regex.test(file.name)) {
          errorMsg = this.translate.instant('CREATE_REQUEST.FILE_INVALID_FORMAT', { sourceName: source.name, sourceFormat: sourceFormat });
          return false;
        }
      }
      return pattern && this.validatePattern(pattern) && regex.test(file.name);
    });
    return { files: files || [], error: errorMsg };
  }

  validatePattern(pattern: string): boolean {
    try {
      new RegExp(pattern);
      return true;
    } catch (e) {
      return false;
    }
  }
}
